import { render, staticRenderFns } from "./bidRD.vue?vue&type=template&id=b2761e82&scoped=true&"
import script from "./bidRD.vue?vue&type=script&lang=js&"
export * from "./bidRD.vue?vue&type=script&lang=js&"
import style0 from "./bidRD.vue?vue&type=style&index=0&id=b2761e82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2761e82",
  null
  
)

export default component.exports